import React from 'react';
import { Flex } from 'antd';
import { LockKeyhole } from 'lucide-react';
import { PreviewHeaderProps } from './PreviewHeader.types';
import ViewAsUserBanner from './ViewAsUserBanner/ViewAsUserBanner';
import PreviewRoleBanner from './PreviewRoleBanner/PreviewRoleBanner';
import CustomShipmentText from '../CustomShipmentText';
import { ExitIcon } from '@/assets/icons/icons';
import { useSpin } from '@/components/SpinContext';
import { useExitPreview } from '@/hooks';
import styles from './PreviewHeader.module.css';

export const PreviewHeader: React.FC<PreviewHeaderProps> = (props) => {
  const { mode, className = '' } = props;
  const { showSpin, hideSpin } = useSpin();
  const { exitPreview } = useExitPreview();

  const handleExitClick = async () => {
    showSpin();
    try {
      await exitPreview();
    } finally {
      hideSpin();
    }
  };

  const isPreviewRoleMode = mode === 'role';
  const isViewAsUserMode = mode === 'user';

  return (
    <div
      className={`${styles.previewBanner} ${className}`.trim()}
      data-testid='preview-header-banner'
      role='region'
      aria-label='Preview Mode Banner'
    >
      <Flex gap={16}>
        {/* Mode-specific content */}
        {isViewAsUserMode && <ViewAsUserBanner />}

        {isPreviewRoleMode && <PreviewRoleBanner />}

        <Flex className={styles.readOnlyBadge} align='center' gap={8}>
          <LockKeyhole width={'17px'} height={'17px'} />
          <CustomShipmentText
            text={'Read only'}
            fontWeight={600}
            color={'#fff'}
          />
        </Flex>
      </Flex>

      {/* Persistent Exit action control on far right */}
      <button
        type='button'
        className={styles.exitControl}
        onClick={handleExitClick}
        data-testid='exit-preview-button'
        aria-label='Exit preview mode'
      >
        <ExitIcon />
        <span>Exit</span>
      </button>
    </div>
  );
};

export default PreviewHeader;
